import React, { Component } from 'react';

class LoadingScreen extends Component {
    render() {
        const { isLoading } = this.props;

        if (!isLoading) return null; // If not loading, don't render anything

        return (
            <div>
                <style>
                    {`
          /* Full-screen overlay */
          .loading-overlay {
            position: fixed;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            background: rgba(0, 0, 0, 0.6); /* Semi-transparent black */
            display: flex;
            justify-content: center;
            align-items: center;
            z-index: 1000; /* Ensure it stays on top */
          }

          /* Spinner */
          .spinner {
            border: 4px solid rgba(255, 255, 255, 0.3); /* Light grey border */
            border-top: 4px solid white; /* White top border */
            border-radius: 50%;
            width: 50px;
            height: 50px;
            animation: spin 1s linear infinite; /* Infinite rotation */
          }

          /* Keyframes for spinning effect */
          @keyframes spin {
            from {
              transform: rotate(0deg);
            }
            to {
              transform: rotate(360deg);
            }
          }
          `}
                </style>
                <div className="loading-overlay">
                    <div className="spinner"></div>
                </div>
            </div>
        );
    }
}

export default LoadingScreen;
